/**
 * Display helpers for numeric columns.
 *
 * The dim/weight columns on inv_levels, inv_catalog, inv_trans2 and freight are
 * decimal(12,3), so a value of 48 comes back as 48.000. These trim the trailing
 * zeros the scale introduces while keeping any real fractional part.
 */

/** 48 -> "48", 48.500 -> "48.5", null -> "" */
export const fmtNum = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  return Number.isFinite(n) ? String(n) : String(value);
};

/** Joins L/W/H into a display string, substituting placeholder for missing parts. */
export const fmtDims = (len, wdt, hgt, { separator = '×', placeholder = '—' } = {}) =>
  [len, wdt, hgt].map((v) => fmtNum(v) || placeholder).join(separator);
